import { cn } from '@/lib/utils'
import { Icon } from './icon'
import { DetailRow, RowStrong } from './detail-row'
import type { CartaoLinha, CartaoPayload } from '@/lib/export/types'

function LinhaPreview({ l }: { l: CartaoLinha }) {
  if (l.strong) {
    const tone = l.tone === 'neg' ? 'neg' : l.tone === 'brand' ? 'brand' : 'ink'
    return <RowStrong label={l.label} value={l.value} tone={tone} />
  }
  return <DetailRow label={l.label} value={l.value} sub={l.sub} />
}

/**
 * Prévia HTML do cartão exportável — usa o MESMO CartaoPayload que o PNG/PDF,
 * então o que aparece aqui é o que sai no arquivo. Sempre com o logo (como no arquivo).
 */
export function CartaoPreview({ payload }: { payload: CartaoPayload }) {
  const isNeg = payload.tone === 'neg'
  return (
    <div className="overflow-hidden rounded-xl border border-line bg-surface shadow-lift">
      <div
        className={cn(
          'px-[22px] py-5',
          isNeg ? 'bg-gradient-to-br from-neg to-[#8a2626]' : 'bg-gradient-to-br from-brand to-[#0c4f55]'
        )}
      >
        <div className="mb-3.5 flex items-center gap-1.5">
          <div className="flex h-[22px] w-[22px] items-center justify-center bg-white/20">
            <Icon name="calculator" size={13} className="text-white" />
          </div>
          <span className="text-[13px] font-semibold text-white">
            Calcula<span className="text-on-brand-softer">MEI</span>
          </span>
        </div>
        <div className={cn('mb-1.5 text-[13px]', isNeg ? 'text-white/80' : 'text-on-brand-soft')}>
          {payload.heroLabel}
        </div>
        <div className="flex items-baseline gap-1">
          <span className="font-mono text-[38px] font-semibold leading-[0.95] tracking-[-0.03em] text-white tabular-nums">
            {payload.heroValue}
          </span>
          {payload.heroSuffix && (
            <span className={cn('text-base', isNeg ? 'text-white/70' : 'text-on-brand-softer')}>
              {payload.heroSuffix}
            </span>
          )}
        </div>
      </div>

      <div className="px-[22px] py-4">
        {payload.linhas.map((l, i) => (
          <LinhaPreview key={i} l={l} />
        ))}
      </div>

      {/* Rodapé de marca — sempre, igual ao arquivo exportado. */}
      <div className="flex items-center justify-between border-t border-line-soft bg-background px-[22px] py-2.5">
        <span className="font-mono text-[11px] text-ink-mute">calculamei.com.br</span>
        <span className="text-[11px] text-ink-faint">Calcule o seu →</span>
      </div>
    </div>
  )
}
